import moment from 'moment';

const processWinRateApiData = (data) => {
    let newData = [];
    newData = data.map((item) => {
        item.startedAt = Math.floor(new Date(item.startedAt).getTime() / 1000);
        item.firstRowDuration = moment.utc(item.roundDuration[0] * 1000).format('mm:ss');
        item.secondRowDuration = moment.utc(item.roundDuration[1] * 1000).format('mm:ss');
        item.thirdRowDuration = moment.utc(item.roundDuration[2] * 1000).format('mm:ss');
        item.detail.winnerCharacterClassChoice = item.detail.winnerCharacterClassChoice.split(', ');
        item.detail.loserCharacterClassChoice = item.detail.loserCharacterClassChoice.split(', ');
        item.detail.winnerUpgradeChoice = item.detail.winnerUpgradeChoice[0].split(', ');
        item.detail.loserUpgradeChoice = item.detail.loserUpgradeChoice[0].split(', ');

        return item;
    });
    return newData;
};

const winRateService = { processWinRateApiData };
export default winRateService;
